export default "__VITE_ASSET__ab2b5be7__"